import { FormControl, FormErrorMessage, Input } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { Announcement } from "../../types/announcement.types";
import { forwardRef, useImperativeHandle } from "react";

export type AnnouncementFormHandler = {
	valid: () => Promise<boolean>;
	values: () => Partial<Announcement>;
};
type AnnouncementFormProps = { value?: Partial<Announcement> };

const AnnouncementForm = forwardRef<
	AnnouncementFormHandler,
	AnnouncementFormProps
>(({ value }, ref) => {
	const methods = useForm();

	useImperativeHandle(ref, () => ({
		valid: () => {
			return methods.trigger();
		},
		values: () => {
			return methods.getValues() as Partial<Announcement>;
		},
	}));
	return (
		<FormProvider {...methods}>
			<form>
				<FormControl isInvalid={!!methods.formState.errors.title}>
					<Input
						id="title"
						placeholder="Titre"
						defaultValue={value?.title ?? ""}
						{...methods.register("title", {
							required: "Ce champ est obligatoire",
						})}
					></Input>
					<FormErrorMessage>
						<>{methods.formState.errors?.title?.message}</>
					</FormErrorMessage>
				</FormControl>

				<FormControl isInvalid={!!methods.formState.errors.content} mt={4}>
					<Input
						id="content"
						placeholder="Description"
						defaultValue={value?.content ?? ""}
						aria-multiline
						{...methods.register("content", {
							required: "Ce champ est obligatoire",
						})}
					></Input>
					<FormErrorMessage>
						<>{methods.formState.errors?.content?.message}</>
					</FormErrorMessage>
				</FormControl>
			</form>
		</FormProvider>
	);
});

export default AnnouncementForm;
